// import moment from "moment";

const formData = {
  full_name: "",
  residential_address: "",
  occupation: "",
  date_of_birth: "",
  business_address: "",
  date_of_incorp: "",
  RC_no: "",
  telephone_no: "",
  email: "",
  website: "",
  // details
  registeration_no: "",
  engine_no: "",
  chassis_no: "",
  make: "",
  model: "",
  type_of_body: "",
  year_manufacture: "",
  seat_capacity: "",
  datae_purchase: "",
  proposes_sum: "",
  // third page
  cover_type: "",
  private_use: "",
  commercial_use: "",
  soleOwnerOfVehicle: "",
  notSoleOwnerOfVehiStateParticular: "",
  isVehicleHirePurchased: "",
  ifHirePurchasedStateNameOfFinancedCompany: "",
  // forth
  general_nature_of_goods_carried: "",
  do_u_undertake_cartage_for_people: "",
  has_the_vehicle_been_altered: "",
  ifAlterdAndUndertakeCartageGiveDetails: "",
  isItUsedToCarryPeopleForReward: "",
  isTheVehicleUsedForPublicService: "",
  State_class_of_vehicle_licence: "",
  //
  proposersName: "",
  scanSignature: null,
  date: "",

  certificationNum: "",
  futureDate: "",
};

export default formData;
